export default __webpack_public_path__ + "static/media/notConnect.768db398.svg";